import { useQuery } from "@apollo/client";
import { useHistory, useParams } from "react-router-dom";
import {
  GetMeetingNewPageQueryQuery,
  GetMeetingNewPageQueryQueryVariables,
} from "types/graphql-schema";

import getMeetingQuery from "@apps/meeting-new/graphql/get-meeting-query";
import MeetingsOverviewSidebar from "@apps/meetings/sidebar";
import Sidebar from "@components/sidebar/sidebar";

const MeetingSidebar = () => {
  const { meetingGroupId, meetingId } = useParams<{
    meetingGroupId: string;
    meetingId: string;
  }>();
  const history = useHistory();
  const { data } = useQuery<
    GetMeetingNewPageQueryQuery,
    GetMeetingNewPageQueryQueryVariables
  >(getMeetingQuery, {
    variables: { meetingId: parseInt(meetingId) },
  });

  const handleClose = () => {
    history.goBack();
  };

  return (
    <Sidebar
      title={data?.meeting?.title ?? undefined}
      titleTo={`/meeting/${meetingGroupId}/${meetingId}`}
      onClose={handleClose}
    >
      <MeetingsOverviewSidebar hideMeetingBot meetingId={parseInt(meetingId)} />
    </Sidebar>
  );
};

export default MeetingSidebar;
